"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSearchQueryString = exports.formatDateFilterToString = exports.constructSortParam = exports.constructFilterParamList = void 0;
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _isBoolean = _interopRequireDefault(require("lodash/isBoolean"));
var _migrationHelpers = require("./migrationHelpers");
var _types = require("../types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const toSortString = sort => "".concat(sort.direction === _types.IssueSortingDirection.Desc ? "-" : "").concat(sort.attribute);
const constructSortParam = sort => {
  return Array.isArray(sort) ? sort.map(toSortString).join(",") : toSortString(sort);
};
exports.constructSortParam = constructSortParam;
const formatDateFilterLimit = date => date instanceof Date ? JSON.stringify(date) : date || "";
const formatDateFilterToString = value => "".concat(formatDateFilterLimit(value.startDate), "...").concat(formatDateFilterLimit(value.endDate));
exports.formatDateFilterToString = formatDateFilterToString;
const getStringFilterTuple = (property, value) => {
  if (value.length === 0) {
    return null;
  }
  return ["filter[".concat(property, "]"), value];
};
const getDateFilterTuple = (property, value) => {
  if (!value.startDate && !value.endDate) {
    return null;
  }
  return ["filter[".concat(property, "]"), formatDateFilterToString(value)];
};
const getEntityIdOrListFilterTuple = (property, value) => ["filter[".concat(property, "]"), Array.isArray(value) ? value.join(",") : value];
const getCustomAttributeFilterTuples = (property, value) => {
  const ids = Object.keys(value);
  return ids.map(id => {
    let filterValue = value[id];
    if (Array.isArray(value[id])) {
      filterValue = value[id].join(",");
    }
    return ["filter[".concat(property, "][").concat(id, "]"), filterValue];
  });
};
const getViewableTuple = (property, value) => ["filter[".concat(property, "]"), value];
const constructFilterParamList = filterBy => {
  const filterParamList = [];
  const filterObjectArray = Object.entries(filterBy).map(_ref => {
    let [property, value] = _ref;
    return [_migrationHelpers.IssueFilterPropertyMigration.serialize(property), value];
  });
  for (const [property, value] of filterObjectArray) {
    if ((0, _isEmpty.default)(value) && !(0, _isBoolean.default)(value)) {
      continue;
    } else if (property === "title" || property === "search") {
      filterParamList.push(getStringFilterTuple(property, value));
    } else if (_types.IssueDateFilters.includes(property)) {
      filterParamList.push(getDateFilterTuple(property, value));
    } else if (property === "customAttributes") {
      getCustomAttributeFilterTuples(property, value).map(tuple => filterParamList.push(tuple));
    } else if (property === "viewable") {
      filterParamList.push(getViewableTuple(property, value));
    } else {
      filterParamList.push(getEntityIdOrListFilterTuple(property, value));
    }
  }
  return filterParamList.filter(tuple => tuple !== null);
};
exports.constructFilterParamList = constructFilterParamList;
const excludeNonStringFilterTuples = filterTuples => {
  return filterTuples.filter(filterTuple => typeof filterTuple[1] !== "object");
};
const getSearchQueryString = _ref2 => {
  let {
    limit,
    offset,
    sortBy,
    filterBy: inputFilterBy
  } = _ref2;
  let filterBy = inputFilterBy;
  const searchParams = new URLSearchParams();
  if (limit) {
    searchParams.set("limit", limit.toString());
  }
  if (offset) {
    searchParams.set("offset", offset.toString());
  }
  if (sortBy) {
    searchParams.set("sortBy", constructSortParam(sortBy));
  }
  if (filterBy) {
    if (filterBy.deleted !== true && filterBy.valid === undefined) {
      filterBy = {
        ...filterBy,
        valid: true
      };
    }
    const filterParamList = excludeNonStringFilterTuples(constructFilterParamList(filterBy));
    for (const [param, value] of filterParamList) {
      searchParams.set(param, value);
    }
  }
  const search = searchParams.toString();
  return search ? "?".concat(search) : "";
};
exports.getSearchQueryString = getSearchQueryString;
//# sourceMappingURL=fetchHelpers.js.map